import type { IntlShape } from 'react-intl';
import { messages } from '../localization/messages.ts';
import type { VoiceRealtimeState } from '../services/voice-realtime.service.ts';

export interface DockNarrationState {
  voiceActive: boolean;
  voiceState: VoiceRealtimeState;
  voiceCaption: string;
  voiceRunBusy: boolean;
  runInFlight: boolean;
  narration: string;
}

/** Selects the single composer line from independent voice and task activity. */
export function resolveDockNarration(state: DockNarrationState, intl: IntlShape) {
  const working = state.runInFlight || (state.voiceActive && state.voiceRunBusy);
  if (state.voiceActive && state.voiceState === 'connecting') {
    return { text: intl.formatMessage(messages.voiceConnecting), variant: 'status' as const };
  }
  if (state.voiceActive && state.voiceCaption.trim()) {
    return { text: state.voiceCaption, variant: 'caption' as const };
  }
  let text = '';
  if (working) {
    text = state.narration || intl.formatMessage(messages.working);
  } else if (
    state.voiceActive &&
    (state.voiceState === 'thinking' || state.voiceState === 'building')
  ) {
    text = intl.formatMessage(messages.voiceThinking);
  }
  return { text, variant: 'status' as const };
}
